(function () {
  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function closestElement(target, selector) {
    if (!target || !selector) return null;

    var element = target.nodeType === 1 ? target : target.parentElement;
    while (element) {
      if (element.matches && element.matches(selector)) {
        return element;
      }
      element = element.parentElement;
    }

    return null;
  }

  function initOne(root) {
    if (!root || root.getAttribute('data-stock-list-initialized') === 'true') {
      return;
    }

    root.setAttribute('data-stock-list-initialized', 'true');

    var activePanel = getActivePanel(root);
    if (activePanel) {
      ensurePanelReady(activePanel);
    }

    root.addEventListener('tabswitcher:change', function (event) {
      if (!event || !event.detail) return;

      var panel = findPanelByHandle(root, event.detail.handle);
      if (!panel) return;

      ensurePanelReady(panel);
    });
  }

  function getActivePanel(root) {
    return root.querySelector('[data-tab-panel].is-active:not([hidden])') ||
      root.querySelector('[data-tab-panel]:not([hidden])') ||
      root.querySelector('[data-tab-panel]');
  }

  function findPanelByHandle(root, handle) {
    if (!handle) return null;

    var panels = qsa(root, '[data-tab-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-tab-panel') === handle) {
        return panels[i];
      }
    }

    return null;
  }

  function ensurePanelReady(panel) {
    buildGeoFilter(panel);

    var currentGeo = panel.getAttribute('data-stock-geo-current') || 'all';
    if (!hasGeoOption(panel, currentGeo)) {
      currentGeo = 'all';
    }

    applyGeoFilter(panel, currentGeo);
  }

  function hasGeoOption(panel, geoKey) {
    var tabs = qsa(panel, '[data-stock-geo-tab]');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-stock-geo-tab') === geoKey) {
        return true;
      }
    }

    return false;
  }

  function buildGeoFilter(panel) {
    var filter = panel.querySelector('[data-stock-country-filter]');
    if (!filter) return;

    var cards = toArray(panel.querySelectorAll('[data-stock-country]'));
    if (cards.length === 0) {
      filter.hidden = true;
      panel.removeAttribute('data-stock-geo-mode');
      return;
    }

    if (filter.getAttribute('data-stock-geo-built') === 'true') {
      return;
    }

    var filterData = getFilterData(cards);
    if (!filterData || !filterData.options || filterData.options.length <= 1) {
      filter.hidden = true;
      panel.removeAttribute('data-stock-geo-mode');
      return;
    }

    panel.setAttribute('data-stock-geo-mode', filterData.mode);

    filter.setAttribute('role', 'tablist');
    filter.setAttribute(
      'aria-label',
      filterData.mode === 'state' ? 'Stock list states' : 'Stock list countries'
    );

    var markup = '';
    markup += geoButtonMarkup('all', 'All', true);

    for (var i = 0; i < filterData.options.length; i++) {
      var option = filterData.options[i];
      markup += geoButtonMarkup(option.key, option.label, false);
    }

    filter.innerHTML = markup;
    filter.hidden = false;
    filter.setAttribute('data-stock-geo-built', 'true');

    filter.addEventListener('click', function (event) {
      var button = closestElement(event.target, '[data-stock-geo-tab]');
      if (!button || !filter.contains(button)) return;

      applyGeoFilter(panel, button.getAttribute('data-stock-geo-tab'));
    });

    filter.addEventListener('keydown', function (event) {
      var activeTab = closestElement(event.target, '[data-stock-geo-tab]');
      if (!activeTab || !filter.contains(activeTab)) return;

      var tabs = qsa(filter, '[data-stock-geo-tab]');
      var index = tabs.indexOf(activeTab);
      if (index < 0) return;

      var nextIndex = -1;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = tabs.length - 1;
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        applyGeoFilter(panel, activeTab.getAttribute('data-stock-geo-tab'));
        return;
      } else {
        return;
      }

      event.preventDefault();
      tabs[nextIndex].focus();
      applyGeoFilter(panel, tabs[nextIndex].getAttribute('data-stock-geo-tab'));
    });

  }

  function getFilterData(cards) {
    var countries = [];
    var countriesSeen = {};

    for (var i = 0; i < cards.length; i++) {
      var cardCountryKey = (cards[i].getAttribute('data-stock-country') || 'other').trim() || 'other';
      var cardCountryLabel = (cards[i].getAttribute('data-stock-country-label') || 'Other').trim() || 'Other';

      if (!countriesSeen[cardCountryKey]) {
        countriesSeen[cardCountryKey] = true;
        countries.push({ key: cardCountryKey, label: cardCountryLabel });
      }
    }

    if (countries.length > 1) {
      return {
        mode: 'country',
        options: countries
      };
    }

    var states = [];
    var statesSeen = {};

    for (var j = 0; j < cards.length; j++) {
      var cardStateKey = (cards[j].getAttribute('data-stock-state') || '').trim();
      var cardStateLabel = (cards[j].getAttribute('data-stock-state-label') || '').trim();
      if (!cardStateKey || !cardStateLabel) continue;

      if (!statesSeen[cardStateKey]) {
        statesSeen[cardStateKey] = true;
        states.push({ key: cardStateKey, label: cardStateLabel });
      }
    }

    if (states.length > 1) {
      return {
        mode: 'state',
        options: states
      };
    }

    return null;
  }

  function applyGeoFilter(panel, geoKey) {
    var mode = panel.getAttribute('data-stock-geo-mode') || 'country';
    var cards = toArray(panel.querySelectorAll('[data-stock-country]'));
    var tabs = toArray(panel.querySelectorAll('[data-stock-geo-tab]'));
    var emptyMessage = panel.querySelector('[data-stock-region-empty]');
    var visibleCount = 0;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var cardGeo = mode === 'state'
        ? (card.getAttribute('data-stock-state') || '').trim()
        : ((card.getAttribute('data-stock-country') || 'other').trim() || 'other');

      var shouldShow = geoKey === 'all' || cardGeo === geoKey;
      card.hidden = !shouldShow;
      card.style.display = shouldShow ? '' : 'none';

      if (shouldShow) {
        visibleCount += 1;
      }
    }

    for (var j = 0; j < tabs.length; j++) {
      var tab = tabs[j];
      var isActive = tab.getAttribute('data-stock-geo-tab') === geoKey;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    }

    panel.setAttribute('data-stock-geo-current', geoKey);

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount !== 0;
    }

  }

  function geoButtonMarkup(key, label, isActive) {
    return '<button type="button" class="stock-list__country-tab fabric-tabs__tab' +
      (isActive ? ' is-active' : '') +
      '" data-stock-geo-tab="' + escapeHtml(key) +
      '" role="tab" aria-selected="' + (isActive ? 'true' : 'false') +
      '" tabindex="' + (isActive ? '0' : '-1') +
      '">' + escapeHtml(label) + '</button>';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function boot(scope) {
    qsa(scope || document, '[data-stock-list]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;

    var roots = [];
    if (event.target.matches && event.target.matches('[data-stock-list]')) {
      roots.push(event.target);
    } else {
      roots = qsa(event.target, '[data-stock-list]');
    }

    roots.forEach(function (root) {
      root.removeAttribute('data-stock-list-initialized');
    });

    if (roots.length) {
      roots.forEach(initOne);
    } else {
      boot(event.target);
    }
  });
})();
